module.exports = __webpack_public_path__ + "static/media/goalkeeper.f1f2cba9.jpeg";